import {Button, Card, CardContent, Textarea} from '@nlabs/gothamjs';
import {FormEvent, useState} from 'react';

import {Hero} from '../../components/Hero';
import {Page} from '../../components/Page';
import {Section} from '../../components/Section';
import ufatSupportWaterHero from '../../assets/ufat-support-water-hero.png';
import {IVR_PHONE, STORE_URL, SUPPORT_EMAIL} from '../../lib/site';
import {button, card, cardContent, cardTitle, gridThree, paragraphMuted} from '../../lib/styles';
import {Route} from '../../types/routes';

export const Support = ({route}: {route: Route}) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;

    if(!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    setMessage(`Ticket intake is being configured. Please email ${SUPPORT_EMAIL} for support while we finish setup.`);
    form.reset();
  };

  return (
    <Page route={route}>
      <Hero
        backgroundImage={ufatSupportWaterHero}
        copyTone="dark"
        imageLabel="Blue water droplet ripple"
        kicker="Support and contact"
        subtitle="Use the support form placeholder, email support directly, or find UFAT Studios store and phone details here."
        title="Tell us what needs attention."
        tone="cyan"
      />
      <Section className="nx-section-support" title="Support ticket placeholder">
        <form className="grid grid-cols-1 gap-[18px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] bg-white p-[clamp(22px,4vw,36px)] min-[841px]:grid-cols-2" onSubmit={handleSubmit}>
          <label className="grid gap-2 font-extrabold text-[var(--nx-ink)]">Name<input className="min-h-[46px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" name="name" required /></label>
          <label className="grid gap-2 font-extrabold text-[var(--nx-ink)]">Email<input className="min-h-[46px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" name="email" required type="email" /></label>
          <label className="grid gap-2 font-extrabold text-[var(--nx-ink)]">Company<input className="min-h-[46px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" name="company" /></label>
          <label className="grid gap-2 font-extrabold text-[var(--nx-ink)]">Category
            <select className="min-h-[46px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" name="category" required>
              <option value="">Select a category</option>
              <option>UFAT Studios publishing support</option>
              <option>UFAT Labs coding support</option>
              <option>General inquiry</option>
            </select>
          </label>
          <label className="col-span-full grid gap-2 font-extrabold text-[var(--nx-ink)]">Subject<input className="min-h-[46px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" name="subject" required /></label>
          <label className="col-span-full grid gap-2 font-extrabold text-[var(--nx-ink)]">Message<Textarea className="min-h-[46px] resize-y rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" name="message" required rows={6} /></label>
          <Button className={`${button} col-span-full`} type="submit">Prepare Ticket</Button>
          {message ? <p className="col-span-full m-0 rounded-[var(--nx-radius)] bg-[var(--nx-soft)] p-3.5 leading-[1.55] text-[var(--nx-text)]" role="status">{message}</p> : null}
        </form>
      </Section>
      <Section className="nx-section-contact-details" title="Contact details">
        <div className={gridThree}>
          <Card className={card}>
            <CardContent className={cardContent}>
              <h3 className={cardTitle}>UFAT Studios, Inc.</h3>
              <p className={paragraphMuted}>Book publishing, author support, and store access.</p>
              <a className="mt-[18px] inline-block font-extrabold" href={STORE_URL}>UFAT Studios Store</a>
            </CardContent>
          </Card>
          <Card className={card}>
            <CardContent className={cardContent}>
              <h3 className={cardTitle}>UFAT Labs, Inc.</h3>
              <p className={paragraphMuted}>Coding, mobile, and web app development.</p>
              <a className="mt-[18px] inline-block font-extrabold" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </CardContent>
          </Card>
          <Card className={card}>
            <CardContent className={cardContent}>
              <h3 className={cardTitle}>Phone</h3>
              <p className={paragraphMuted}>{IVR_PHONE}</p>
              <span className="mt-[18px] inline-block font-extrabold">Placeholder phone details</span>
            </CardContent>
          </Card>
        </div>
      </Section>
    </Page>
  );
};
